var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardsView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.137 4.309H.665a.538.538 0 0 0-.522.523v10.534c0 .285.253.523.522.523h2.472a.538.538 0 0 0 .522-.523V4.832c.016-.285-.237-.523-.522-.523zm8.427 0h-5.94a.538.538 0 0 0-.523.523v10.534c0 .285.253.523.523.523h5.94a.538.538 0 0 0 .523-.523V4.832a.527.527 0 0 0-.523-.523zM16.507.063H.602C.317.063.063.317.063.586V2.36c0 .286.254.523.523.523h15.905a.538.538 0 0 0 .523-.523V.586c-.016-.27-.222-.523-.507-.523zm0 4.246h-2.471a.538.538 0 0 0-.523.523v10.534c0 .285.253.523.523.523h2.47a.538.538 0 0 0 .524-.523V4.832c.016-.285-.238-.523-.523-.523z",
    fill: "var(--tru-gunmetal)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsView);
export default ForwardRef;